import { render, staticRenderFns } from "./Filedownload.vue?vue&type=template&id=5d539de4&scoped=true&"
import script from "./Filedownload.vue?vue&type=script&lang=js&"
export * from "./Filedownload.vue?vue&type=script&lang=js&"
import style0 from "./Filedownload.vue?vue&type=style&index=0&id=5d539de4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d539de4",
  null
  
)

export default component.exports